export default {"src":"/_next/static/media/ship-camps-text-only-dark.7550ac00.svg","height":16,"width":78,"blurWidth":0,"blurHeight":0};